export default "__VITE_ASSET__Ck6jl$Vp__";